import { createSelector } from '@reduxjs/toolkit';
import type { IState } from 'redux/state';

const readDevelopmentState = (state: IState) => state.development;

export const getShowResourceIds = createSelector(
  [readDevelopmentState],
  state => state.showResourceIds
);

export const getPretendToBeNonMemoryUser = createSelector(
  [readDevelopmentState],
  state => state.pretendToBeNonMemoryUser
);

export const getMaskFullStory = createSelector(
  [readDevelopmentState],
  state => state.maskFullStory
);

export const getInjectSyntheticData = createSelector(
  [readDevelopmentState],
  state => state.injectSyntheticData
);

export const getExcludeTrackerEntriesFromTimelyApiRequest = createSelector(
  [readDevelopmentState],
  state => state.excludeTrackerEntriesFromTimelyApiRequest
);

export const getForceShowInstallMemoryMessage = createSelector(
  [readDevelopmentState],
  state => state.forceShowInstallMemoryMessage
);

export const getForceShowNoCalendarConnected = createSelector(
  [readDevelopmentState],
  state => state.forceShowNoCalendarConnected
);

export const getForceFullOnboardingFlow = createSelector(
  [readDevelopmentState],
  state => state.forceFullOnboardingFlow
);

export const getIsAnyDiagnosticActive = createSelector(
  [getShowResourceIds, getPretendToBeNonMemoryUser, getMaskFullStory, getInjectSyntheticData],
  (...diagnostics) => diagnostics.some(diagnosticActive => diagnosticActive === true)
);

export const getShowStackTraceModal = (state: IState) => state.development.showStackTraceModal;

export const getInitialStackTrace = (state: IState) => state.development.initialStackTrace;
